import React, { useState,useEffect } from "react";
import { Loader, ThankYouContent } from '../../components';

const ThankYouWebinarContainer = (props) => {

  const imgHero = require('../../assets/header_webinar.jpg');

  const arrayLoad = [
    imgHero
  ]
  useEffect(() => {
    document.title = "Thank you for your registration"
    
  }, []);
 

  
  return (
    <React.Fragment>
      <ThankYouContent 
        title={props.title}
        paragraph={props.paragraph}
        noCta={props.noCta} />
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-10793268603"></script> 
      <script dangerouslySetInnerHTML={{
        __html: 
          "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-10793268603'); "
      }}></script>
      <script dangerouslySetInnerHTML={{
        __html: "gtag('event', 'conversion', {'send_to': 'AW-10793268603/lm3QCK_h3oMDEPvq0Joo'}); "
      }}></script>
    </React.Fragment>
  );
};

export default ThankYouWebinarContainer;
